module.exports = __webpack_public_path__ + "img/main_2_1.b27792b1.png";